import moment from "moment";

const LocalDateTimeDisplay = ({ isoDate }) => {
  const formattedDate = moment(isoDate).local().format("M/D/YYYY h:mm:ss A");

  return <span>{formattedDate}</span>;
};

export default LocalDateTimeDisplay;
